import { render, staticRenderFns } from "./product-sub-requests.modal.vue?vue&type=template&id=5dc3262c&scoped=true&"
import script from "./product-sub-requests.modal.vue?vue&type=script&lang=js&"
export * from "./product-sub-requests.modal.vue?vue&type=script&lang=js&"
import style0 from "./product-sub-requests.modal.vue?vue&type=style&index=0&id=5dc3262c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc3262c",
  null
  
)

export default component.exports